import React, { createContext, useState } from 'react';

export const NavigationContext = createContext();

const NavigationContextProvider = (props) => {

    const pages = [
        {
            id: 'presentation',
            titre_court: 'Présentation',
            titre: 'Présentation de l\'UV',
            uri: '/',
            icon: 'home'
        },
        {
            id: 'modalites',
            titre_court: 'Modalités de l\'UV',
            titre: 'Modalités de l\'UV',
            uri: '?page=modalites',
            icon: 'chart'
        },
        {
            id: 'videos',
            titre_court: 'Vidéos',
            titre: 'Vidéos sur l\'UV',
            uri: '?page=videos',
            icon: 'video'
        },
        {
            id: 'quizz',
            titre_court: 'Quizz',
            titre: 'Quizz sur l\'UV',
            uri: '?page=quizz',
            icon: 'quizz'
        },
        {
            id: 'tutoriels',
            titre_court: 'Tutoriels',
            titre: 'Tutoriels',
            uri: '?page=tutoriels',
            icon: 'game'
        }
    ]

    const [page, setPageState] = useState(pages.filter(p => p.active));

    const [menuVisible, setMenuVisibleState] = useState(false)

    const setPage = (pageID = 'presentation') => {
        setPageState(pages.filter(p => p.id === pageID)[0]);
    }

    const setMenuVisible = () => {
        setMenuVisibleState(!menuVisible)
    }

    const hideMenu = () => {
        setMenuVisibleState(false)
    }

    return (
        <NavigationContext.Provider value={{ page, pages, menuVisible, setMenuVisible, setPage, hideMenu }}>
            {props.children}
        </NavigationContext.Provider>
    );
}

export default NavigationContextProvider;